// Normalise (sans accents) et met en minuscule
export const norm = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

// Vérifie que TOUS les tokens sont présents
export const matchAllTokens = (haystack, q) => {
  const tokens = norm(q).split(/\s+/).filter(Boolean);
  if (!tokens.length) return true;
  const hay = norm(haystack);
  return tokens.every((t) => hay.includes(t));
};

// Badge de statut
export const statusChip = (status) => {
  const map = {
    "Non Réglé": "bg-rose-600 text-white",
    Réglé: "bg-emerald-600 text-white",
    "En Attente": "bg-amber-300 text-slate-900",
    Annulé: "bg-slate-900 text-white",
    Remboursé: "bg-violet-600 text-white",
    "Partiellement Réglé": "bg-emerald-200 text-slate-900",
  };
  return map[status] || "bg-slate-200 text-slate-900";
};

// Tag plan de paiement
export const paymentPlanTag = (plan) => {
  switch (plan) {
    case "One-time":
      return "1x";
    case "Two-times":
      return "2x";
    case "Three-times":
      return "3x";
    case "Four-times":
      return "4x";
    case "Five-times":
      return "5x";
    default:
      return "";
  }
};

// Saisons uniques depuis liste de règlements
export const getUniqueSeasons = (list) => {
  const set = new Set();
  list.forEach((r) => {
    const d = new Date(r.date_achat);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const season = month >= 8 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
    set.add(season);
  });
  return Array.from(set);
};

// Check si une date est dans la saison "YYYY-YYYY"
export const isWithinSeason = (date, season) => {
  if (!season) return true;
  const [startYear, endYear] = season.split("-").map(Number);
  const seasonStart = new Date(`${startYear}-07-01T00:00:00`);
  const seasonEnd = new Date(`${endYear}-06-30T23:59:59`);
  const d = new Date(date);
  return d >= seasonStart && d <= seasonEnd;
};

export const getReminderHistory = (reglement) => {
  const value = reglement?.rappels_paiement;

  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  return [];
};

export const getReminderCount = (reglement) => {
  return getReminderHistory(reglement).length;
};

export const formatReminderDate = (dateValue) => {
  if (!dateValue) return "Date inconnue";

  try {
    return new Date(dateValue).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (error) {
    return "Date invalide";
  }
};
